import React from "react";
import { isLightHex } from "@/lib/format";

// Palette Monday.com: badge pieni, vivaci, testo bianco
const VARIANTS = {
  success: { bg: '#00C875' },
  warning: { bg: '#FDAB3D' },
  error:   { bg: '#E2445C' },
  danger:  { bg: '#E2445C' },
  info:    { bg: '#579BFC' },
  gold:    { bg: '#B7955B' },
  neutral: { bg: '#797E93' },
  purple:  { bg: '#A25DDC' },
  teal:    { bg: '#4ECCC6' },
  pink:    { bg: '#FF158A' },
  fire:    { bg: '#E10600' },
};

export function StatusBadge({ children, variant = 'neutral', customColor, style: extraStyle = {} }) {
  const bg = customColor || (VARIANTS[variant] || VARIANTS.neutral).bg;
  const light = isLightHex(bg);

  return (
    <span
      className="inline-flex items-center text-[10px] font-bold uppercase tracking-[0.07em] px-2 py-0.5 whitespace-nowrap"
      style={{
        background: bg,
        color: light ? '#0A192F' : '#fff',
        textShadow: light ? 'none' : '0 1px 0 rgba(0,0,0,0.10)',
        borderRadius: 2,
        ...extraStyle,
      }}
    >
      {children}
    </span>
  );
}
